@if (form()) {
  <form [formGroup]="form()" class="flex h-full flex-col">
    <dojo-swiper [options]="swiperOptions()">
      <ng-content></ng-content>
    </dojo-swiper>

    <ng-content select=".controls,[controls]"></ng-content>
  </form>
}
